// CANONICAL COPY (GH #7115). src/constants/obligations/obl-vulnerability-scan.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-vulnerability-scan',
  title: 'Perform vulnerability scan',
  description:
    'Execute vulnerability scans of enterprise assets. Document findings and prioritise remediation. Auto-satisfied when the Microsoft Defender feed has been synced within the freshness window; falls back to manual evidence upload otherwise.',
  category: 'technical',
  scfIds: ['SCF-OPS-004'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    // Tier 1: Defender feed presence (highest fidelity — system attestation
    // that vulnerability scanning is happening continuously).
    {
      type: 'defender-feed-fresh',
      maxAgeDays: 90,
      description: 'Microsoft Defender feed has been synced within the last 90 days',
    },
    // Tier 2: a published policy still satisfies the obligation for tenants
    // who don't use Defender — keeps the manual escape hatch open.
    {
      type: 'document-published',
      description: 'A published vulnerability scan / management policy covers these controls',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
